import React, { useState } from 'react';
import OperationalAction from 'components/Operational/operationalAction';
import Portal from 'portal/Portal';
import TaskForm from 'containers/Pages/Tasks/CleanerTasks/form';
import { useSelector } from 'react-redux';
import { getSiteDetailsRaw } from './Selectors/siteSelectors';
import EventsForm from 'containers/Pages/Events/Layouts/baseEventForm';
import { setSiteName } from 'utils/helper/site';
import eventTypes from 'static/event_categories_types.json';
import { getSecurityCompanyServices } from 'reducers/securityCompany';
import { checkIfServicesHasIsTask } from 'utils/helper/product';

// This structure helps in displaying site on event panel map
const transformSiteForEvents = ({ site }) => {
  return {
    id: site.id,
    siteName: setSiteName(site),
    name: site.name,
    siteId: site.siteId,
    bizId: site?.businessClient.id,
    businessClientId: site?.businessClient.businessClientId,
    businessClientName: site?.businessClient.businessClientName,
    boundary: site.boundary,
    address: site?.location[0]?.address,
  };
};
// this transform makes sure that it has the same structure required to display involvedCompanies on event form
const transformBizClientToCompany = ({ site }) => {
  return [
    {
      name: {
        display: site.businessClient.businessClientName,
        displayValue: site.businessClient.businessClientName,
        type: 'text',
        value: site.businessClient.businessClientName,
      },
    },
  ];
};

const Operational = () => {
  const [tasksOpen, setTasksOpen] = useState(false);
  const [eventsOpen, setEventsOpen] = useState(false);
  const services = useSelector(state => getSecurityCompanyServices(state));
  const siteDetails = useSelector(state => getSiteDetailsRaw(state));
  const getActionItem = type => {
    switch (type) {
      case 'tasks':
        return {
          btnText: 'Create task',
          btnSize: 'xl',
          btnColor: 'primary',
          btnClickHandler: setTasksOpen,
          alignment: 'left',
        };
      case 'events':
        return {
          btnText: 'Create Event',
          btnSize: 'xl',
          btnColor: 'primary',
          btnClickHandler: setEventsOpen,
          alignment: 'left',
        };
      default:
        return null;
    }
  };
  return (
    <>
      {checkIfServicesHasIsTask({ services }) && (
        <OperationalAction type={'button'} item={getActionItem('tasks')} />
      )}
      <OperationalAction type={'button'} item={getActionItem('events')} />
      {tasksOpen && (
        <Portal id={'portal'}>
          <TaskForm
            closeForm={() => setTasksOpen(prev => !prev)}
            size={'portal'}
            defaultFieldValues={{
              site: siteDetails,
              departments: siteDetails.departments,
            }}
            disabledFields={['site', 'departments']}
            disablePresist={true}
            editMode={false}
            getAllTemplateTasks={true}
          />
        </Portal>
      )}
      {eventsOpen && (
        <Portal id={'portal'}>
          <EventsForm
            editMode={false}
            closeForm={() => setEventsOpen(prev => !prev)}
            size={'portal'}
            defaultFieldValues={{
              // make sure keys of this object should exactly match the field name of the component
              site: transformSiteForEvents({
                site: siteDetails,
              }),
              eventCategory: eventTypes.find(
                et => et.category === 'Site Incident',
              )['category'],
              involvedCompanies: transformBizClientToCompany({
                site: siteDetails,
              }),
            }}
            disablePresist={true}
          />
        </Portal>
      )}
    </>
  );
};

export default Operational;
